// src/theme.js

const theme = {
  colors: {
    primary: "#6366F1",   // Indigo
    secondary: "#10B981", // Teal
    danger: "#EF4444",    // Red
    dangerLight: "#FEE2E2", // Light red background for error boxes
    dangerText: "#B91C1C",  // Dark red text
    warning: "#F59E0B",   // Yellow
    success: "#22C55E",   // Green
    grayLight: "#F3F4F6",
    grayDark: "#1F2937",
    background: "#F9FAFB",
  },

  font: {
    family: {
      sans: `"Inter", "ui-sans-serif", "system-ui"`,
    },
    size: {
      sm: "0.875rem",
      base: "1rem",
      lg: "1.125rem",
      xl: "1.25rem",
      "2xl": "1.5rem",
      "3xl": "1.875rem",
      "4xl": "2.25rem",
    },
    weight: {
      normal: 400,
      medium: 500,
      bold: 700,
    },
  },

  radius: {
    sm: "0.25rem",
    md: "0.375rem",
    lg: "0.5rem",
    xl: "1rem",
    "2xl": "1.5rem",
    full: "9999px",
  },

  shadow: {
    soft: "0 4px 8px rgba(0, 0, 0, 0.06)",
    xl: "0 12px 20px rgba(0, 0, 0, 0.08)",
  },

  spacing: {
    xs: "0.25rem",   // 4px
    sm: "0.5rem",    // 8px
    md: "1rem",      // 16px
    lg: "1.5rem",    // 24px
    xl: "2rem",      // 32px
    "2xl": "3rem",   // 48px
    "3xl": "4rem",   // 64px
  },
};

export default theme;
